import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-success-modal',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './success-modal.component.html',
  styleUrl: './success-modal.component.scss'
})
export class SuccessModalComponent {
onExit() {
this.dialogRef.close(false);
this.router.navigate([this.continueRoute])
}
onSaveDraft() {
throw new Error('Method not implemented.');
}
  @Input() title: string = 'Success!';
  @Input() message: string = 'Your case has been sent to OneFamily for their review and approval.';
  @Input() continueButtonText: string = 'Continue';
  @Input() continueRoute: string = '/dashboard/distributor/applicants';
  @Input() Status :string='';
  @Input() exitButtonText:string ='Exit';
  
  constructor(
    public dialogRef: MatDialogRef<SuccessModalComponent>,
    private router: Router
  ) {}
  
  onContinue(): void {
    this.dialogRef.close(true);
    this.router.navigate(['/dashboard/distributor/applicants']);
  }
} 